<template>
    <FanaticsProvider ref="refFanatics">
        <AudioProvider :sound-defs="instantRipsSoundDefs">
            <StateManager>
                <Bounds>
                    <slot />
                </Bounds>
            </StateManager>
        </AudioProvider>
    </FanaticsProvider>
</template>

<script setup>
    import { usePageEnter } from '#imports';
    import { ref } from 'vue';

    import AudioProvider from '../AudioProvider';
    import ColorPaletteProvider from '../ColorPaletteProvider';
    import FanaticsProvider from './FanaticsProvider';
    import StateManager from './StateManager';
    import { Bounds } from '~/components/gl/Bounds';
    import { instantRipsSoundDefs } from '~/core/audio';

    const refFanatics = ref(null);

    usePageEnter(() => {
        refFanatics.value.ready = true;
    });
</script>
